import log from 'loglevel';
import React, { useEffect, useState } from 'react';
import { usePlayerContext } from '../Context';
import { use } from 'i18next';
import { Events, SizePlayerEvents, LogoPosition } from '../../types/player';

const Logo = () => {
  const { sdk } = usePlayerContext();

  const prefix = sdk.getClassNamePrefix();
  const logo = sdk.options().getLogo();
  const [style, setStyle] = useState({});
  const [show, setShow] = useState(true);

  let listeners: any = [];

  if (!logo || !logo.url) return null;

  //if (!/\.(jpeg|jpg|gif|png|bmp|webp|svg)$/i.test(logo)) return null;
  

  function buildStyle(playerWidth: number, playerHeight: number) {
    let style = {};
    switch (logo.position) {
      case LogoPosition.TOP_LEFT:
        style = {
          top: '0',
          left: '0',
        };
        break;
      case LogoPosition.TOP_RIGHT:
        style = {
          top: '0',
          right: '0',
        };
        break;
      case LogoPosition.BOTTOM_LEFT:
        style = {
          bottom: '0',
          left: '0',
        };
        break;
      case LogoPosition.BOTTOM_RIGHT:
        style = {
          bottom: '0',
          right: '0',
        };
        break;
    }  
    if(logo.maxWidth)
       (style as any).maxWidth = playerWidth * (logo.maxWidth || 10) / 100;
    setStyle(style);  
  }

  useEffect(() => {

    listeners.push(sdk.on(Events.CHANGE_SIZE, (size: SizePlayerEvents) => {
      buildStyle(size.width, size.height);
    }));

    listeners.push(sdk.on(Events.MOUSE_OVER, (mouseOver: boolean) => {
      if(!mouseOver && logo.hideOnMouseOut) {
        setShow(false);
      }
      else {
        setShow(true);
      }
    }));
    
    return () => {
      listeners.forEach((off: any) => off());
    }

  }, []);

  if(!show) return null;

  return (
    <div
      className={`${prefix}-player-control ${sdk.getClassNamePrefix()}-player-control-logo`}
      style={style}
    >
      <img src={logo.url} />
    </div>
  );
};

export default Logo;
